import { Box, Card, Link, Text } from '@nimbus-ds/components';
import { generatePath, Link as LinkRoute } from 'react-router-dom';
import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { ExternalLink, useResponsive } from 'commons/components';
import { useGetCountry } from 'domains/Auth/hooks';
import { useGetEcommerceNaPraticaQuery } from 'domains/Dashboard/dashboardApi';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import { trackingEnpClickNewOnboarding202411 } from 'domains/Dashboard/tracking';
import { partnersAppsRoutes } from 'domains/PartnersApps';
import ImageEcommerceEnAccion from './ecommerce-en-acción.png';
import ImageEcommerceNaPratica from './enp-image-2.png';

const ECOMMERCE_APP_ID = '1006';
const BREAKPOINT_MD_WIDTH = 672;
const IMAGE_DESKTOP_HEIGHT_BR = '64px';
const IMAGE_DESKTOP_HEIGHT_DEFAULT = '82px';
const IMAGE_DESKTOP_WIDTH = '188px';
const IMAGE_MOBILE_ASPECT_RATIO = '33 / 14';
const BORDER_RADIUS_BR = '6px';
const BORDER_RADIUS_DEFAULT = '8px';

const MX_ENP_URL =
  'https://www.youtube.com/watch?v=bbZUJ4GEQzc&list=PL5kR_3HfjG5aHT24xcKvyhqFzWz4HcOdt';

const BR_ENP_URL = 'https://youtu.be/4nUpfLfSK_E?si=5Xt-ZLq9f3WrDRvT';

function NewEcommerceNaPraticaCard() {
  const t = useTranslationDashboard('improveStore_202411.e-commerce');
  const country = useGetCountry();
  const isBrazil = country === Country.BR;

  const { data, isLoading } = useGetEcommerceNaPraticaQuery();
  const { isMobile: isMobileResponsive } = useResponsive(BREAKPOINT_MD_WIDTH);

  const imageBorderRadius = isBrazil ? BORDER_RADIUS_BR : BORDER_RADIUS_DEFAULT;
  const imageDesktopHeight = isBrazil
    ? IMAGE_DESKTOP_HEIGHT_BR
    : IMAGE_DESKTOP_HEIGHT_DEFAULT;

  if (isLoading) return null;

  return (
    <ShowByCountry allowedCountries={[Country.BR, Country.MX]}>
      <Box>
        <Card>
          <Card.Body>
            <Box
              display="flex"
              alignItems="center"
              paddingRight={
                isBrazil ? (isMobileResponsive ? 'none' : '3') : '3'
              }
              gap={
                isBrazil
                  ? {
                      lg: '4',
                      md: '4',
                      xs: '2',
                    }
                  : '4'
              }
              flexDirection={{
                lg: 'row',
                md: 'row',
                xs: 'column',
              }}
            >
              <img
                alt="ecommercenapratica-img"
                src={
                  country === Country.MX
                    ? ImageEcommerceEnAccion
                    : ImageEcommerceNaPratica
                }
                style={
                  isMobileResponsive
                    ? {
                        width: '100%',
                        aspectRatio: IMAGE_MOBILE_ASPECT_RATIO,
                        borderRadius: imageBorderRadius,
                        objectFit: 'cover',
                        ...(isBrazil ? { flexShrink: 0 } : {}),
                      }
                    : {
                        height: imageDesktopHeight,
                        width: IMAGE_DESKTOP_WIDTH,
                        borderRadius: imageBorderRadius,
                        objectFit: 'cover',
                        ...(isBrazil ? { flexShrink: 0 } : {}),
                      }
                }
              />
              <Box
                display="flex"
                flexDirection="column"
                gap="1"
                justifyContent="center"
                maxWidth="703px"
              >
                <Box display="flex" flexDirection="column" gap="1">
                  <Text
                    fontSize="caption"
                    color="neutral-textHigh"
                    lineHeight="caption"
                  >
                    {t('title')}
                  </Text>
                  <Text
                    fontSize="caption"
                    color="neutral-textLow"
                    lineHeight="caption"
                  >
                    {t('description')}
                  </Text>
                </Box>
                {country === Country.BR && !data?.hasInstalled && (
                  <Link
                    textDecoration="none"
                    fontSize="caption"
                    as={LinkRoute}
                    to={generatePath(partnersAppsRoutes.authorization, {
                      id: ECOMMERCE_APP_ID,
                    })}
                    appearance="primary"
                    onClick={trackingEnpClickNewOnboarding202411(
                      'primeira-venta',
                    )}
                  >
                    {t('linkText')}
                  </Link>
                )}
                {(country === Country.MX || data?.hasInstalled) && (
                  <ExternalLink
                    textDecoration="none"
                    fontSize="caption"
                    appearance="primary"
                    href={country === Country.MX ? MX_ENP_URL : BR_ENP_URL}
                  >
                    {t('linkText')}
                  </ExternalLink>
                )}
              </Box>
            </Box>
          </Card.Body>
        </Card>
      </Box>
    </ShowByCountry>
  );
}

export default NewEcommerceNaPraticaCard;
